import React from 'react';
import { graphql } from 'gatsby';

import {
    Layout,
    useTranslate,
    Head as DefaultHead,
} from '@solublestudio/gatsby-theme-soluble-source';
import { CaseStudyTemplate } from '@solublestudio/soluble-design-system';
import useSchema from '../hooks/useSchema';
import EditorWrapper from '../components/EditorWrapper';

export function Head({ data, ...props }) {
    const structuredData = useSchema('article', data.page);

    return (
        <DefaultHead structuredData={structuredData} data={data} {...props} />
    );
}

export default function CaseStudy({ data }) {
    const pageData = data?.page;
    const _ = useTranslate();

    return (
        <Layout data-header-default-height>
            <EditorWrapper>
                <CaseStudyTemplate
                    json={pageData}
                    year={_['casestudies.year'].text}
                    services={_['casestudies.services'].text}
                />
            </EditorWrapper>
        </Layout>
    );
}

// TODO: Cuando publiquemos la nueva página de clientes, eliminar el "PreSolublablaNotion"
export const query = graphql`
    query CaseStudy($id: String) {
        page: notionPage(id: { eq: $id }) {
            ...PreSolublablaNotion
            ...NotionArticle
            services
            client
            year
        }
    }
`;
